import { useMutation, useQueryClient } from '@tanstack/react-query';

import { teamsKeys } from '~teacher/hook/team/teamsKeys';
import { subscriptionKeys } from '~teacher/hook/useSubscriptions';

import { TeamsMembersData } from '../../../api/teams/getTeamsMembers';
import { removeMembersFromTeam } from '../../../api/teams/removeMembersFromTeam';

export function useRemoveMembersFromTeam() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeMembersFromTeam,
    onSettled: (_data, _error, { teamId }) => [
      queryClient.invalidateQueries(teamsKeys.members(teamId), {
        refetchType: 'all',
      }),
      queryClient.invalidateQueries(subscriptionKeys.list(), {
        refetchType: 'all',
      }),
    ],
    onMutate: async ({ teamId, publicIds }) => {
      await queryClient.cancelQueries(teamsKeys.members(teamId));

      const previousMembers = queryClient.getQueryData<TeamsMembersData>(
        teamsKeys.members(teamId)
      );

      if (previousMembers) {
        const updatedMembers = previousMembers.filter(
          (member) => !publicIds.includes(member.publicId)
        );

        queryClient.setQueryData(teamsKeys.members(teamId), updatedMembers);
      }

      return { previousMembers, teamId };
    },
    onError: (
      _error,
      _variables,
      context: { previousMembers: TeamsMembersData; teamId: string }
    ) => {
      if (context?.previousMembers) {
        queryClient.setQueryData(
          teamsKeys.members(context.teamId),
          context.previousMembers
        );
      }
    },
  });
}
